import React, {useEffect, useState} from "react";

export default function WarrantyCard({warranty, onGenerate}) {
    const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return ""; // Handle null or undefined values
        const [datePart, timePart] = dateTimeString.split(" "); // Split date and time
        const [day, month, year] = datePart.split("/"); // Extract day, month, year
        const [hours, minutes] = timePart.split(":"); // Extract hours and minutes
        return `${year}-${month}-${day}T${hours}:${minutes}`; // ISO format for datetime-local input
    };

    const formatPayloadDateTime = (isoDateTime) => {
        if (!isoDateTime) return ""; // Handle null or undefined values
        const [datePart, timePart] = isoDateTime.split("T");
        const [year, month, day] = datePart.split("-");
        const [hours, minutes] = timePart.split(":");
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    const [editableProducts, setEditableProducts] = useState([]);
    const [editableWarranty, setEditableWarranty] = useState({
        created_at: formatDateTime(warranty.created_at),
        first_name: warranty.first_name || "",
        last_name: warranty.last_name || "",
        bank_order_id: warranty.bank_order_id || "",
    });

    useEffect(() => {
        setEditableProducts(
            (warranty.products || []).map(product => ({
                id: product.id,
                name: product.name || "",
                warranty_date: product.warranty_date,
            }))
        );
    }, [warranty.products]);

    const handleInputChange = (index, field, value) => {
        setEditableProducts(prevProducts => {
            const newProducts = [...prevProducts];
            newProducts[index][field] = value;
            return newProducts;
        });
    };

    const handleWarrantyChange = (field, value) => {
        setEditableWarranty(prev => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleGenerateClick = () => {
        const payload = {
            ...editableWarranty,
            created_at: formatPayloadDateTime(editableWarranty.created_at),
            products: editableProducts.map(product => ({
                ...product,
                warranty_date: product.warranty_date,
            })),
        };
        onGenerate(payload);
    };

    return (
        <div className="col-xxl-12 pt-5">
            <div className="card card-flush py-4 flex-row-fluid">
                <div className="card-header">
                    <div className="card-title">
                        <h2>Warranty Information</h2>
                    </div>
                </div>
                <div className="card-body pt-0">
                    <div>
                        <strong>Order ID:</strong>
                        <input
                            type="text"
                            className="form-control mb-2"
                            disabled={true}
                            value={editableWarranty.bank_order_id}
                        />
                    </div>
                    <div>
                        <strong>User Name:</strong>
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="First Name"
                            value={editableWarranty.first_name}
                            onChange={(e) => handleWarrantyChange("first_name", e.target.value)}
                        />
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Last Name"
                            value={editableWarranty.last_name}
                            onChange={(e) => handleWarrantyChange("last_name", e.target.value)}
                        />
                    </div>
                    <div>
                        <strong>Purchase Date:</strong>
                        <input
                            type="datetime-local"
                            className="form-control mb-2"
                            value={editableWarranty.created_at}
                            onChange={(e) => handleWarrantyChange("created_at", e.target.value)}
                        />
                    </div>

                    {editableProducts.map((product, index) => (
                        <div key={product.id} className="mt-4">
                            <h4>Product {warranty.products[index].name}</h4>
                            <input
                                type="text"
                                name="product_name"
                                className="form-control mb-2"
                                placeholder="Product name"
                                value={product.name}
                                onChange={(e) => handleInputChange(index, "name", e.target.value)}
                            />
                            <input
                                type="text"
                                name="product_warranty_date"
                                className="form-control mb-2"
                                value={product.warranty_date}
                                onChange={(e) => handleInputChange(index, "warranty_date", e.target.value)}
                            />
                        </div>
                    ))}
                </div>

                <div className="card-footer pt-3">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleGenerateClick}
                    >
                        Generate Warranty
                    </button>
                </div>
            </div>
        </div>
    );
}
